"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from "react";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { AuthContext } from "@/components/auth/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { commonApiFetch } from "@/services/api/common-api";
import type { CommunityMembersQuery } from "@/app/network/page";
import { SortDirection } from "@/entities/ISort";
import type { Page } from "@/helpers/Types";
import type { ApiCommunityMemberOverview } from "@/generated/models/ApiCommunityMemberOverview";
import { ApiCommunityMembersSortOption } from "@/generated/models/ApiCommunityMembersSortOption";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useGroupMutations } from "@/hooks/groups/useGroupMutations";
export default function GroupCreateTest(t0) {
  const $ = _c(37);
  const {
    groupConfig,
    disabled
  } = t0;
  const {
    requestAuth,
    setToast,
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== requestAuth) {
    t1 = {
      requestAuth
    };
    $[0] = requestAuth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    runTest,
    isTesting
  } = useGroupMutations(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      page: 1,
      page_size: 1,
      sort: ApiCommunityMembersSortOption.Level,
      sort_direction: SortDirection.DESC,
      group_id: undefined
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [params, setParams] = useState(t2);
  let t3;
  if ($[3] !== params.group_id || $[4] !== params.page || $[5] !== params.page_size || $[6] !== params.sort || $[7] !== params.sort_direction) {
    t3 = [QueryKey.COMMUNITY_MEMBERS_TOP, {
      page: params.page,
      pageSize: params.page_size,
      sort: params.sort,
      sortDirection: params.sort_direction,
      groupId: params.group_id
    }];
    $[3] = params.group_id;
    $[4] = params.page;
    $[5] = params.page_size;
    $[6] = params.sort;
    $[7] = params.sort_direction;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== params) {
    t4 = async () => await commonApiFetch({
      endpoint: "community-members/top",
      params
    });
    $[9] = params;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !!params.group_id;
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      placeholderData: keepPreviousData,
      enabled: t5
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    isFetching,
    data: members
  } = useQuery(t6);
  let t7;
  if ($[15] !== connectedProfile?.handle || $[16] !== disabled || $[17] !== groupConfig || $[18] !== isTesting || $[19] !== runTest || $[20] !== setToast) {
    t7 = async () => {
      if (isTesting || disabled) {
        return;
      }
      setParams(_temp);
      const result = await runTest({
        payload: groupConfig,
        nameFallback: `${connectedProfile?.handle ?? "Group"} Test Run`
      });
      if (!result.ok) {
        if (result.reason !== "auth") {
          setToast({
            message: result.error,
            type: "error"
          });
        }
        return;
      }
      setParams(prev_0 => ({
        ...prev_0,
        group_id: result.group.id
      }));
    };
    $[15] = connectedProfile?.handle;
    $[16] = disabled;
    $[17] = groupConfig;
    $[18] = isTesting;
    $[19] = runTest;
    $[20] = setToast;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const onTest = t7;
  const loading = isFetching || isTesting;
  const t8 = disabled || isTesting;
  const t9 = `${disabled ? "tw-text-iron-500 tw-opacity-70" : "tw-text-iron-400 hover:tw-bg-iron-800 hover:tw-text-iron-300"} tw-rounded-lg tw-border tw-border-solid tw-border-iron-950 tw-bg-iron-950 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-shadow-sm tw-ring-1 tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out hover:tw-border-iron-800 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700`;
  let t10;
  if ($[22] !== loading) {
    t10 = loading && <CircleLoader />;
    $[22] = loading;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>Test</span>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-3">{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onTest || $[28] !== t12 || $[29] !== t8 || $[30] !== t9) {
    t13 = <button type="button" disabled={t8} onClick={onTest} className={t9}>{t12}</button>;
    $[27] = onTest;
    $[28] = t12;
    $[29] = t8;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== members) {
    t14 = !!members && <div className="tw-self-center"><div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm"><FontAwesomeIcon icon={faUsers} className="tw-size-5 tw-flex-shrink-0 tw-text-iron-300" aria-hidden="true" /><div className="tw-inline-flex tw-items-center tw-gap-x-1.5"><span className="tw-font-normal tw-text-iron-400">Members count:</span><span className="tw-font-medium tw-text-primary-400">{members.count}</span></div></div></div>;
    $[32] = members;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-space-x-4">{t13}{t14}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}
function _temp(prev) {
  return {
    ...prev,
    group_id: undefined
  };
}